import {
  Banner,
  BannerTypesEnum,
  Box,
  DashboardNotificationBannerProvider,
  Flex,
  ModalProvider,
  useScreenResolution,
  ViewerContext,
  DropdownOptions,
  TooltipPopup,
} from 'dash-ui';

import UpgradeSubscriptionModal from 'common/components/UpgradeSubscriptionModal/UpgradeSubscriptionModal';

import {
  FAQsWidget,
  ReactionsWidget,
  NotificationBanner,
  PortfolioViewsWidget,
  PropertyAlertsWidget,
  BrokersActivityWidget,
  PropertyUpdatesWidget,
  CurrencyConverterWidget,
  MortgageCalculatorWidget,
} from './components/';
import { InfoWidgetsWrapper } from './Dashboard.styles';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { SubscriptionChangeConfirmationModal } from 'pages/ProfilePage/components/ProfileBilling/components';

function DesktopDashboard() {
  return (
    <Flex w="100%" alignSelf="stretch" flexDirection="column">
      <Flex flex={1} w="100%">
        <Flex mr={6} flex={2} flexDirection="column" overflow="auto">
          <Flex mt={8} w="100%">
            <PortfolioViewsWidget />
          </Flex>
          <Flex mt={8} w="100%">
            <BrokersActivityWidget />
          </Flex>
        </Flex>
        <Flex mt={6} maxWidth={354} flex={1} flexDirection="column">
          <Flex>
            <MortgageCalculatorWidget />
          </Flex>
          <Flex mt={6}>
            <CurrencyConverterWidget />
          </Flex>
          <Flex mt={6}>
            <FAQsWidget />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}

function TabletDashboard() {
  return (
    <Flex w="100%" alignSelf="stretch" flexDirection="column">
      <Flex mt={8} w="100%">
        <PortfolioViewsWidget />
      </Flex>
      <Flex w="100%" mt={6} flex={1}>
        <Flex flex={1} mr={6}>
          <MortgageCalculatorWidget />
        </Flex>
        <Flex flex={1} flexDirection="column">
          <Flex w="100%">
            <CurrencyConverterWidget />
          </Flex>
          <Flex mt={6}>
            <FAQsWidget />
          </Flex>
        </Flex>
      </Flex>
      <Flex w="100%" mt={6}>
        <BrokersActivityWidget />
      </Flex>
    </Flex>
  );
}

function MobileDashboard() {
  return (
    <Flex w="100%" alignSelf="stretch" flexDirection="column">
      <Flex w="100%">
        <PortfolioViewsWidget />
      </Flex>
      <Flex w="100%" mt={3} flexDirection="column" flex={1}>
        <Flex>
          <MortgageCalculatorWidget />
        </Flex>
        <Flex mt={3}>
          <CurrencyConverterWidget />
        </Flex>
        <Flex mt={3}>
          <FAQsWidget />
        </Flex>
      </Flex>
      <Flex w="100%" mt={6}>
        <BrokersActivityWidget />
      </Flex>
    </Flex>
  );
}

const BannerWrapper = () => {
  const { t } = useTranslation('pages');
  const { subscription } = useContext(ViewerContext);

  return subscription?.subscriptionProduct?.name === 'Premium' ? (
    <Box my={3}>
      <Banner
        message={t('pages:dashboardPage.banner.notifications.freePlanUpdate')}
        type={BannerTypesEnum.WARNING}
      />
    </Box>
  ) : (
    <></>
  );
};

function DashboardPage() {
  const {
    devices: { isMobile, isTablet, isDesktop, isLaptop },
  } = useScreenResolution();
  return (
    <DashboardNotificationBannerProvider>
      <ModalProvider>
        <Box pt={1} w="100%">
          <DropdownOptions />
          <TooltipPopup />
          <BannerWrapper />
          <NotificationBanner />
          <InfoWidgetsWrapper>
            <PropertyAlertsWidget />
            <PropertyUpdatesWidget />
          </InfoWidgetsWrapper>
          {(isLaptop || isDesktop) && <DesktopDashboard />}
          {isTablet && <TabletDashboard />}
          {isMobile && <MobileDashboard />}
          <SubscriptionChangeConfirmationModal />
          <UpgradeSubscriptionModal />
        </Box>
      </ModalProvider>
    </DashboardNotificationBannerProvider>
  );
}

export default DashboardPage;
